<form [formGroup]="rangeForm">
  <label class="label-form-control range-label">
    Range
  </label>
  <div class="form-field check-field">
    <span class="checkbox-icon">
      <input type="checkbox" formControlName="isIndependent" id="isIndependent" />
      <label class="inline-icon icon-editor-checkbox-light-unchecked" for="isIndependent"> Use independent axis range </label>
    </span>
  </div>
  <div class="range-input-container">
    <input class="form-control form-control-sm range-input" placeholder="min" type="number" formControlName="min"
      (keydown.enter)="$event.target.blur()" />
    <span class="range-input-separator">&#8722;</span>
    <input class="form-control form-control-sm pull-right range-input" placeholder="max" type="number"
      formControlName="max" (keydown.enter)="$event.target.blur()" />
  </div>
</form>
